export default function Benefits() {
  const benefits = [
    {
      icon: 'ri-time-line',
      title: '検索・入手の手間を省いて本業に集中できる',
      description: '論文検索や入手の時間を削減し、診療や研究に専念できます'
    },
    {
      icon: 'ri-search-line',
      title: '希望するテーマ・条件に沿った最適論文をリストアップ',
      description: '専門スタッフが適切な論文を厳選してご提案します'
    },
    {
      icon: 'ri-file-list-3-line',
      title: '一論文から複数件まで柔軟に対応',
      description: 'ご要望に応じて必要な件数を迅速に対応いたします'
    },
    {
      icon: 'ri-presentation-line',
      title: '医局・学会・学術発表・教育に活用しやすい',
      description: '様々な場面で活用できる形式で論文をご提供します'
    }
  ];

  return (
    <section className="py-12 sm:py-16 md:py-20 px-4 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl sm:text-3xl font-bold text-center mb-3 text-gray-900">
          主なメリット・利用シーン
        </h2>
        <p className="text-center text-gray-600 mb-8 sm:mb-12 text-sm sm:text-base">
          論文検索・入手代行サービスで得られる4つのメリット
        </p>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 mb-12 sm:mb-16">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-5 sm:p-6 shadow-sm hover:shadow-md transition-shadow border border-gray-100"
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-blue-50 rounded-lg flex-shrink-0">
                  <i className={`${benefit.icon} text-2xl sm:text-3xl text-blue-600`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-bold text-gray-900 mb-2 text-base sm:text-lg leading-snug">
                    {benefit.title}
                  </h3>
                  <p className="text-gray-600 text-sm sm:text-base leading-relaxed">
                    {benefit.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mb-8">
          <h3 className="text-xl sm:text-2xl font-bold text-gray-900">
            こんな場面でご活用いただけます
          </h3>
        </div>

        <div className="bg-white rounded-xl p-6 sm:p-8 shadow-sm border border-gray-100 max-w-4xl mx-auto">
          <div className="flex flex-wrap items-center justify-center gap-3 sm:gap-4">
            <div className="flex items-center gap-2 bg-blue-50 text-blue-600 px-4 py-2 rounded-full">
              <i className="ri-stethoscope-line text-xl"></i>
              <span className="font-semibold text-sm sm:text-base whitespace-nowrap">診療の参考資料</span>
            </div>
            <div className="flex items-center gap-2 bg-teal-50 text-teal-600 px-4 py-2 rounded-full">
              <i className="ri-flask-line text-xl"></i>
              <span className="font-semibold text-sm sm:text-base whitespace-nowrap">研究活動</span>
            </div>
            <div className="flex items-center gap-2 bg-purple-50 text-purple-600 px-4 py-2 rounded-full">
              <i className="ri-presentation-line text-xl"></i>
              <span className="font-semibold text-sm sm:text-base whitespace-nowrap">学会発表</span>
            </div>
            <div className="flex items-center gap-2 bg-orange-50 text-orange-600 px-4 py-2 rounded-full">
              <i className="ri-book-open-line text-xl"></i>
              <span className="font-semibold text-sm sm:text-base whitespace-nowrap">教育・指導</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}